import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animal-protection-report-form',
  templateUrl: './animal-protection-report-form.component.html',
  styleUrls: ['./animal-protection-report-form.component.scss']
})
export class AnimalProtectionReportFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
